import React from 'react';
import styled from 'styled-components/macro';
import Footer from '../Footer/Footer';
import { isMobile } from 'react-device-detect';
import ScrollToTop from '../../hoc/ScrollToTop';

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
  background: #afc0bf;
`;

const GifContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 6.8%;
  height: 40vh;
  max-height: 480px;
  max-width: 640px;
  /* background: silver; */
  overflow: hidden;

  img {
    width: auto;
    height: 101%;
    margin-left: -1%;
    object-fit: contain;
    /* top: 0;
    bottom: 0;
    right: 0;
    left: 0; */
  }
`;

const TextContainer = styled.div`
  position: absolute;
  margin: auto;
  left: 0;
  bottom: 25%;
  right: 0;
  height: 170px;
  width: 286px;
`;

const ContactText = styled.div`
  color: #fff;
  /* color: #861657; */
  text-align: center;
  letter-spacing: 0.5px;
  font-size: 24px;
  line-height: calc(18 / 13);
  font-family: Lato;
  font-weight: 700;
`;

const Mail = styled.a`
  color: #fff;
  /* color: #861657; */

  :hover {
    color: ${() => (!isMobile ? '#93e1d8' : '')};
  }

  :active {
    color: #93e1d8;
  }
`;

const Call = styled.a`
  color: #fff;
  /* color: #861657; */
  text-decoration: none;

  :hover {
    color: ${() => (!isMobile ? '#93e1d8' : '')};
  }

  :active {
    color: #93e1d8;
  }
`;

const Contact = () => {
  return (
    <ScrollToTop>
      <ContactContainer>
        <GifContainer>
          <img src={require('../../assets/images/Contact.gif')} alt="contact" />
        </GifContainer>
        <TextContainer>
          <ContactText>
            Peter Frommann<br></br>
            Platenstraße 14 <br></br>
            50825 Köln <br></br>
            <Mail href="mailto:info@peterfrommann.de">
              info@peterfrommann.de
            </Mail>
            <br />
            <Call href="tel:+491784102973">+49 178 4102973</Call>
          </ContactText>
        </TextContainer>
        <Footer />
      </ContactContainer>
    </ScrollToTop>
  );
};

export default Contact;
